import React from "react";

export default ({ fill = "#0049C6" }) => (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4558 10H0.625V0.16925" stroke={fill} stroke-width="1.25" />
        <circle cx="7.29997" cy="2.63086" r="1.91359" transform="rotate(-45 7.29997 2.63086)" stroke={fill} stroke-width="1.25" />
        <path d="M8.65332 3.98401L10.6394 5.97012" stroke={fill} stroke-width="1.25" />
        <line y1="-0.625" x2="5.61758" y2="-0.625" transform="matrix(0 -1 -1 0 2.38086 8.68109)" stroke={fill} stroke-width="1.25" />
        <line y1="-0.625" x2="2.10659" y2="-0.625" transform="matrix(0 -1 -1 0 4.4873 8.68109)" stroke={fill} stroke-width="1.25" />
        <line y1="-0.625" x2="2.80879" y2="-0.625" transform="matrix(0 -1 -1 0 6.59375 8.68109)" stroke={fill} stroke-width="1.25" />
    </svg>
);